import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AccountService, UserData } from '../../../+state';

@Component({
  selector: 'elm-app-application-header',
  templateUrl: './application-header.component.html',
  styleUrls: ['./application-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationHeaderComponent {
  userData$ = this.userData.userPropertiesFromData$;

  constructor(
    private accountService: AccountService,
    private userData: UserData
  ) {}

  logout() {
    this.accountService.logout();
  }
}
